var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.3333H26.75M20.375 2.95833C20.9386 2.39474 21.703 2.07813 22.5 2.07812C22.8946 2.07812 23.2854 2.15586 23.65 2.30688C24.0146 2.45791 24.3459 2.67927 24.625 2.95833C24.9041 3.23739 25.1254 3.56868 25.2764 3.93329C25.4275 4.29789 25.5052 4.68868 25.5052 5.08333C25.5052 5.47798 25.4275 5.86876 25.2764 6.23337C25.1254 6.59798 24.9041 6.92927 24.625 7.20833L6.91667 24.9167L1.25 26.3333L2.66667 20.6667L20.375 2.95833Z",
    stroke: "#B2FC02",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/editGreen.b6e57e27e067feded73b22efd2cb6323.svg";
export { ForwardRef as ReactComponent };